import { lazy, Suspense } from "react";
import { SubHeading } from "../Components";

// Dynamic import with error boundary support
const LiveMarketBody = lazy(() => import("./LiveMarketBody"));

const LiveMarket = () => {
  return (
    <>
      <SubHeading subTitle="Live Market" />

      <Suspense fallback={<>Loading</>}>
        <LiveMarketBody />
      </Suspense>
    </>
  );
};

export default LiveMarket;
